<div class="container">
  <div class="container-screen-content">
    <div class="divsearch">
      <app-search-bar
        actionText="Pesquisar"
        placeholder="Pesquise por eventos"
        (search)="searchText($event)"
      ></app-search-bar>
      <div class="filter">
        <div class="filters">
          <app-year-select
            #yearSelectId
            [idSchool]="idSchool"
            (selectEvent)="changeYear($event)"
          ></app-year-select>
          <app-classroom-select
            [initialIds]="selectedIdsClassrooms"
            [year]="selectedYear"
            (selectEvent)="handleSelectClassroom($event)"
          ></app-classroom-select>
          <app-profile-select
            [initialIds]="profilesFilter"
            [allProfiles]="true"
            (selectEvent)="handleSelectProfiles($event)"
          ></app-profile-select>
          <app-shows-status-select
            [active]="showStatusFilter"
            (activeChange)="handleSelectShowStatus($event)"
          ></app-shows-status-select>
          <app-shows-month-select
            [active]="showMonthFilter"
            (activeChange)="handleSelectShowMonth($event)"
          ></app-shows-month-select>
          <app-shows-released-select
            [active]="showReleasedFilter"
            (activeChange)="handleSelectShowReleased($event)"
          ></app-shows-released-select>
          <div class="reset-filter">
            <button
              class="btn-reset"
              (click)="resetFilters()"
              [disabled]="disableResetFilters"
            >
              Limpar filtros
            </button>
          </div>
        </div>
      </div>
      <div class="cells-container">
        <app-show-card
          *ngFor="let show of shows"
          [showInfo]="show"
          (deleteEvent)="openActiveDialog($event)"
          (editEvent)="openFormDialog($event)"
          (reportEvent)="openReportDialog($event)"
        ></app-show-card>
      </div>
    </div>
  </div>
  <div class="footer-container">
    <button mat-raised-button
        class="btn-create-show background-primary-color"
        (click)="openFormDialog()">
      + Criar evento
    </button>
  </div>
</div>
